<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>El usuario con id: {{ $route.params.userId }} no se encuentra en la base de datos. </span>
      <span>
        <span>Ver la lista de </span><router-link :to="{name:'usuarios'}" class="text-inherit underline">Todos los usuarios</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="comercial">

      <vx-card card-border class="mb-4" title="Datos del comercial" title-color="dark" collapseAction>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>DNI</span>
            </div>
            <div>
              <vs-input disabled class="w-full" v-model="comercial.dni" name="dni" />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>E-mail</span>
            </div>
            <div>
              <vs-input disabled class="w-full" v-model="comercial.email" type="email" name="email" />
            </div>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>Nombre</span>
            </div>
            <div>
              <vs-input disabled class="w-full" v-model="comercial.nombre" name="nombre" />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>Apellidos</span>
            </div>
            <div>
              <vs-input disabled class="w-full" v-model="comercial.apellidos" name="apellidos" />
            </div>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div>
              <span>Supervisor</span>
            </div>
            <div>
              <vs-input disabled class="w-full" v-model="nombreSupervisor" name="nombre" />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            &nbsp;
          </div>
        </div>
      </vx-card>

      <vs-tabs class="tab-action-btn-fill-conatiner">
        <!-- Operación -->
        <vs-tab label="Ventas anuales" icon-pack="feather" icon="icon-bar-chart">
          <div class="tab-text">
            <comerciales-view-ventas :comercialId="this.comercial.id"/>
          </div>
        </vs-tab>
        <!-- Cliente -->
        <vs-tab label="Detalle de ventas" icon-pack="feather" icon="icon-list">
          <div class="tab-text">
            <comerciales-view-detalle :comercialId="this.comercial.id"/>
          </div>
        </vs-tab>
      </vs-tabs>
        
      <!-- Botóns -->
      <div class="vx-row" id="account-manage-buttons">
        <div class="vx-col flex w-full justify-end">
          <vs-button color="warning" type="border" :to="{ name: 'informesComerciales' }">Volver</vs-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

import ComercialesViewVentas from './ComercialesViewVentas.vue'
import ComercialesViewDetalle from './ComercialesViewDetalle.vue'

export default {
  name: 'ComercialesView',
  components: {
    ComercialesViewVentas,
    ComercialesViewDetalle
  },
  data () {
    return {
      comercial: null,
      supervisor: null,
      user_not_found: false
    }
  },
  computed: {
    nombreSupervisor () {
      let nombre = null
      if (this.supervisor !== null && this.supervisor !== undefined) {
        nombre = `${this.supervisor.nombre} ${this.supervisor.apellidos}`
      }
      return nombre
    }
  },
  methods: {},
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    const comercialId = this.$route.params.comercialId

    await this.$store.dispatch('userManagement/fetchUser', comercialId)
      .then(res => { 
        this.comercial = res.data
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          this.user_not_found = true
          return
        }
        console.error(err) 
      })

    const supervisorId = this.comercial.supervisor

    if (supervisorId !== null && supervisorId !== undefined) {
      await this.$store.dispatch('userManagement/fetchUser', supervisorId)
        .then(res => { 
          this.supervisor = res.data
        })
        .catch(err => {
          console.error(err) 
        })      
    }
    this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
  }
}

</script>